<template>
  <div class="space-y-2">
    <!-- Always render the slot to maintain FormField context -->
    <div v-if="hasPendingChange" class="space-y-2">
      <!-- Show comparison when there are pending changes -->
      <div class="flex items-center justify-between">
        <label class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">{{ label }}</label>
        <Badge variant="outline" class="text-xs">
          {{ t('profile.pending_approval') }}
        </Badge>
      </div>
      
      <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
        <!-- Current Value -->
        <div class="space-y-1">
          <div class="text-xs text-muted-foreground font-medium">{{ t('profile.current') }}</div>
          <div class="p-2 bg-muted rounded-md min-h-[40px] flex items-center">
            <span v-if="displayCurrentValue" class="text-sm">{{ displayCurrentValue }}</span>
            <span v-else class="text-sm text-muted-foreground italic">{{ t('profile.not_set') }}</span>
          </div>
        </div>
        
        <!-- Pending Value -->
        <div class="space-y-1">
          <div class="text-xs text-amber-600 font-medium">{{ t('profile.pending') }}</div>
          <div class="p-2 bg-amber-50 border border-amber-200 rounded-md min-h-[40px] flex items-center">
            <span v-if="displayPendingValue" class="text-sm text-amber-800">{{ displayPendingValue }}</span>
            <span v-else class="text-sm text-amber-600 italic">{{ t('profile.not_set') }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Regular input when no pending changes -->
    <div v-else>
      <slot :label="label" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Badge } from '@/components/ui/badge'
import { t } from '@/entrypoints/translations.js'

const props = defineProps({
  label: {
    type: String,
    required: true
  },
  currentValue: {
    type: [String, Number, Boolean],
    default: null
  },
  pendingValue: {
    type: [String, Number, Boolean],
    default: null
  },
  valueFormatter: {
    type: Function,
    default: null
  }
})

const hasPendingChange = computed(() => {
  return props.pendingValue !== null && props.pendingValue !== undefined
})

const displayCurrentValue = computed(() => {
  if (props.valueFormatter) {
    return props.valueFormatter(props.currentValue)
  }
  return props.currentValue
})

const displayPendingValue = computed(() => {
  if (props.valueFormatter) {
    return props.valueFormatter(props.pendingValue)
  }
  return props.pendingValue
})
</script>
